import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Classes from './pages/Classes';
import Studios from './pages/Studios';
import Events from './pages/Events';
import ClassPasses from './pages/ClassPasses';
import Payment from './pages/Payment';
import Confirmation from './pages/Confirmation';
import AdminLogin from './pages/admin/AdminLogin';
import ForgotPassword from './pages/admin/ForgotPassword';
import ResetPassword from './pages/admin/ResetPassword';
import AdminDashboard from './pages/admin/AdminDashboard';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteSettingsProvider>
          <Toaster position="top-center" />
          <Routes>
            <Route path="/" element={<><Navigation /><Home /></>} />
            <Route path="/classes" element={<><Navigation /><Classes /></>} />
            <Route path="/studios" element={<><Navigation /><Studios /></>} />
            <Route path="/events" element={<><Navigation /><Events /></>} />
            <Route path="/class-passes" element={<><Navigation /><ClassPasses /></>} />
            <Route path="/payment/:bookingId" element={<><Navigation /><Payment /></>} />
            <Route path="/confirmation/:bookingId" element={<><Navigation /><Confirmation /></>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </SiteSettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;